
import {Component, Prop, Vue, Emit, Watch} from 'vue-property-decorator';
import TarafCard from './TarafCard.vue';
import UyapTakipAc from '@/plugins/uyap-plugin/takip_ac/UyapTakipAc';
import TarafKisi from '@/plugins/uyap-plugin/takip_ac/parser/TarafKisi';
import TarafKurum from '@/plugins/uyap-plugin/takip_ac/parser/TarafKurum';
import {DosyaFormDataInterface} from '@/plugins/uyap-plugin/takip_ac/DosyaFormDataInterface';
import {ActionType} from "@/components/forms/form-wizard/eicrapro/TakipHazirlaFormBetaWizard.vue";
import MtsTakipAc from "@/plugins/uyap-plugin/takip_ac/MtsTakipAc";
import {MtsXmlParser} from '@/plugins/uyap-plugin/takip_ac/MtsXmlParser';
import TakipXmlParser from '@/plugins/uyap-plugin/takip_ac/TakipXmlParser';

@Component({
  components: {
    TarafCard,
  },
})
export default class TakipDetailDialog extends Vue {
  @Prop({required: true}) readonly value!: boolean;
  @Prop({type: Object}) readonly initialItem?: UyapTakipAc | MtsTakipAc;
  @Prop({default: false}) readonly isConfirmationMode!: boolean;
  @Prop({default: false}) readonly isMts!: boolean;
  @Prop() actionType!: ActionType;

  currentIndex: number = 0;
  private navigationDebounce = false;

  get confirmationChipText(): string {
    if (this.actionType == ActionType.KUYRUK_TEVZI_VE_AC || this.actionType == ActionType.KUYRUK_TEVZI)
      return 'Kuyruğa Aktar';
    else
      return 'Hemen Aç';
  }

  get confirmationButtonText(): string {
    switch (this.actionType) {
      case ActionType.KUYRUK_TEVZI:
        return 'Kuyruğa Aktar (Tevzi Al)';
      case ActionType.KUYRUK_TEVZI_VE_AC:
        return 'Kuyruğa Aktar (Tevzi Al ve Aç)';
      case ActionType.HEMEN_TEVZI:
        return 'Hemen Aç (Tevzi Al)';
      case ActionType.HEMEN_TEVZI_VE_AC:
        return 'Hemen Aç (Tevzi Al ve Aç)';
      default:
        return 'Onayla';
    }
  }

  alacakKeys = [
    {key: "ilamliList", title: "İlamlı", aciklamaKey: ["dosyaNo", "ilamliKurumAdi"], tarihKey: "ilamTarihi"},
    {key: "cekList", title: "Çek", aciklamaKey: "seriNumarasi", tarihKey: "kesideTarihi"},
    {key: "senetList", title: "Senet", aciklamaKey: "ilamsizTipi", tarihKey: "tanzimTarihi"},
    {key: "policeList", title: "Poliçe", aciklamaKey: "ilamsizTipi", tarihKey: "tanzimTarihi"},
    {key: "kontratList", title: "Kontrat", aciklamaKey: "tasinmazAdresiDetay", tarihKey: "hazirlanisTarihi"},
    {key: "digerList", title: "Diğer", aciklamaKey: "aciklama", tarihKey: "alacakTarihi"},
    {key: "ilamsizList", title: "İlamsız", aciklamaKey: "aciklama", tarihKey: "muacceliyetTarihi"},
  ]

  get internalValue(): boolean {
    return this.value;
  }

  set internalValue(val: boolean) {
    this.$emit('input', val);
  }

  // Dialog açıldığında başlangıç index'ini ayarla ve keyboard listener ekle/kaldır
  @Watch('value')
  onDialogOpen(isOpen: boolean) {
    if (isOpen) {
      // Başlangıç index'ini ayarla
      if (this.initialItem) {
        const array = this.currentArray;
        const index = array.findIndex(d =>
          d.tempId === this.initialItem!.tempId ||
          d.parsedFile === this.initialItem!.parsedFile
        );
        if (index >= 0) {
          this.currentIndex = index;
        } else {
          this.currentIndex = 0;
        }
      } else {
        this.currentIndex = 0;
      }
      // Keyboard listener ekle
      window.addEventListener('keydown', this.handleKeyNavigation);
    } else {
      // Keyboard listener kaldır
      window.removeEventListener('keydown', this.handleKeyNavigation);
    }
  }

  // Vuex getters - dinamik modül seçimi
  get dosyalar(): UyapTakipAc[] | MtsTakipAc[] {
    const module = this.isMts ? 'mtsTakipHazirla' : 'takipHazirla';
    return this.$store.getters[`${module}/dosyalar`] || [];
  }

  get secilenDosyalar(): UyapTakipAc[] | MtsTakipAc[] {
    const module = this.isMts ? 'mtsTakipHazirla' : 'takipHazirla';
    return this.$store.getters[`${module}/secilenDosyalar`] || [];
  }

  isMtsTakipAc(item: UyapTakipAc | MtsTakipAc | null): item is MtsTakipAc {
    return this.isMts && item !== null && 'mtsHarcBilgileri' in item;
  }

  get currentArray(): UyapTakipAc[] | MtsTakipAc[] {
    return this.isConfirmationMode ? this.secilenDosyalar : this.dosyalar;
  }

  // Vuex'ten currentIndex ile item'ı bul
  get item(): UyapTakipAc | MtsTakipAc | null {
    const array = this.currentArray;
    if (!array || array.length === 0) return null;
    if (this.currentIndex < 0 || this.currentIndex >= array.length) return null;
    return array[this.currentIndex];
  }

  // Harç/Masraf listesi computed property
  get harcMasrafList(): any[] {
    if (!this.item) return [];
    if (this.isMtsTakipAc(this.item)) {
      return this.item.mtsHarcBilgileri?.selectedTarafHashList || [];
    }
    return (this.item as UyapTakipAc).harcMasrafList || [];
  }

  // Harç/Masraf toplamı computed property
  get harcMasrafToplam(): number {
    if (!this.item) return 0;
    if (this.isMtsTakipAc(this.item)) {
      // MTS için selectedTarafHashList içindeki toplamı hesapla
      const list = this.item.mtsHarcBilgileri?.selectedTarafHashList || [];
      return list.reduce((sum: number, item: any) => sum + (item.hesapMiktar || 0), 0);
    }
    return (this.item as UyapTakipAc).parsedFile?.harcMasrafToplam || 0;
  }

  get totalCount(): number {
    return this.currentArray?.length || 0;
  }

  get canNavigatePrevious(): boolean {
    return this.currentIndex > 0;
  }

  get canNavigateNext(): boolean {
    return this.currentIndex >= 0 && this.currentIndex < this.totalCount - 1;
  }

  // Sections computed properties
  get alacakliSections(): Array<any> {
    if (!this.item) return [];
    return this.getTarafCards('alacakli');
  }

  get borcluSections(): Array<any> {
    if (!this.item) return [];
    return this.getTarafCards('borclu');
  }

  get ledgerItemCount(): number {
    const parser = this.item?.parsedFile;
    if (!parser) return 0;

    if (this.isMtsTakipAc(this.item)) {
      const ilamsizList = (parser as MtsXmlParser).ilamsizList || [];
      return ilamsizList.reduce(
          (sum: number, {alacakKalemleri}: any) => sum + (alacakKalemleri?.length ?? 0),
          0
      );
    }

    // Normal takip için mevcut mantık
    const list = (parser as TakipXmlParser).isIlamli()
        ? (parser as TakipXmlParser).getIlamliList()
        : (parser as TakipXmlParser).getIlamsizList();

    return list.reduce(
        (sum: number, {alacakKalemleri}: any) => sum + (alacakKalemleri?.length ?? 0),
        0
    );
  }

  @Emit('close')
  close() {
    return;
  }

  navigateToPrevious() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  navigateToNext() {
    if (this.currentIndex < this.totalCount - 1) {
      this.currentIndex++;
    }
  }

  @Emit('cancel')
  handleCancel() {
    return;
  }

  @Emit('approve')
  handleApprove() {
    return;
  }


  handleKeyNavigation(event: KeyboardEvent) {
    // Sadece input/textarea focus'ta değilken çalışsın
    const targetTag = (event.target as HTMLElement)?.tagName?.toLowerCase();
    if (targetTag === 'input' || targetTag === 'textarea' || targetTag === 'select') {
      return;
    }

    // Dialog açık değilse çalışma
    if (!this.value) return;

    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        if (this.navigationDebounce) return;
        this.navigationDebounce = true;
        this.navigateToPrevious();
        setTimeout(() => {
          this.navigationDebounce = false;
        }, 300);
        break;
      case 'ArrowRight':
        event.preventDefault();
        if (this.navigationDebounce) return;
        this.navigationDebounce = true;
        this.navigateToNext();
        setTimeout(() => {
          this.navigationDebounce = false;
        }, 300);
        break;
      case 'Escape':
        event.preventDefault();
        if (!this.isConfirmationMode) {
          this.close();
        }
        break;
    }
  }

  beforeDestroy() {
    // Cleanup: listener'ı kaldırmayı garanti et
    window.removeEventListener('keydown', this.handleKeyNavigation);
  }

  getTarafCards(type: 'alacakli' | 'borclu'): Array<{
    type: 'alacakli' | 'borclu',
    taraf: TarafKisi | TarafKurum
  }> {
    if (!this.item) return [];
    let parser = this.item.parsedFile;
    if (!parser?.tarafList?.length) return [];
    const filterFn =
        type === 'alacakli'
            ? (taraf: TarafKisi | TarafKurum) => taraf.isAlacakli() && taraf.selected
            : (taraf: TarafKisi | TarafKurum) => taraf.isBorclu() && taraf.selected;
    return parser.tarafList.filter(filterFn).map((taraf) => ({type, taraf}));
  }
}
